import { Component } from '@theme/component';

/**
 * A custom element that manages a page popup.
 */
export class PagePopupComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.dialog = this.querySelector('dialog-component');
    this.content = this.querySelector('.apc-page-popup__content');
    document.addEventListener('page-popup:toggle', this.#handlePagePopupToggle);
    window.addEventListener('hashchange', this.#handlePagePopupToggle);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('page-popup:toggle', this.#handlePagePopupToggle);
    window.removeEventListener('hashchange', this.#handlePagePopupToggle);
  }

  #handlePagePopupToggle = async (event) => {
    const handle =
      event.detail?.handle || (location.hash.includes('#popup-') ? location.hash.replace('#popup-', '') : null);
    const insurancePopupContentTemplate = event.detail?.insurancePopupContentTemplate;

    if (!handle) return;

    this.content.innerHTML = '';
    this.dialog.toggleDialog();

    await fetch(`${Theme.routes.root}pages/popup-content/${handle}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const main = html.querySelector('main');

        if (insurancePopupContentTemplate) {
          const stickyBlock = main?.querySelector('.group-block.group-block--sticky-bottom');
          const secondaryLink = stickyBlock?.querySelector('a')?.href || '';

          insurancePopupContentTemplate.innerHTML = insurancePopupContentTemplate.innerHTML.replace(
            'SECONDARY_LINK',
            secondaryLink,
          );

          if (stickyBlock) {
            stickyBlock.outerHTML = insurancePopupContentTemplate.innerHTML;
          } else if (main) {
            main.innerHTML = main.innerHTML + insurancePopupContentTemplate.innerHTML;
          }
        }

        this.content.innerHTML = main?.innerHTML || insurancePopupContentTemplate?.innerHTML || '';
      });

    history.replaceState(null, '', window.location.pathname + window.location.search);
  };
}

if (!customElements.get('page-popup-component')) customElements.define('page-popup-component', PagePopupComponent);
